import React, { useState, useEffect } from 'react';
import { TrendingUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ModuleAlertsPage from '../../shared/components/ModuleAlertsPage';
import localApiAdapter from '../../core/services/localApiAdapter';

const isPending = (status) => ['pending', 'en_attente', 'in_transit'].includes(status);

const VentesAlertsPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.ventes.pages.ventesAlertsPage.${key}`, opts);

  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAlerts();
  }, []);

  const loadAlerts = async () => {
    try {
      setLoading(true);
      const [ordersRes, deliveriesRes, dashboardRes] = await Promise.all([
        localApiAdapter.get('/ventes/commandes'),
        localApiAdapter.get('/ventes/livraisons'),
        localApiAdapter.get('/ventes/dashboard').catch(() => null),
      ]);
      const orders = ordersRes?.data || ordersRes || [];
      const deliveries = deliveriesRes?.data || deliveriesRes || [];
      const dashboard = dashboardRes?.data || dashboardRes || null;

      const pendingOrders = orders.filter((o) => isPending(o.status));
      const pendingDeliveries = deliveries.filter((d) => isPending(d.status));
      const pendingQuotes = Number(dashboard?.orders?.pending || 0);

      const mapped = [
        ...(pendingQuotes > 0
          ? [{
              id: 'quotes-pending',
              type: 'info',
              priority: 'medium',
              title: p('alert_quotes_title'),
              message: p('alert_quotes_message', { count: pendingQuotes }),
              date: new Date().toISOString().split('T')[0],
              read: false,
            }]
          : []),
        ...pendingDeliveries.map((delivery) => ({
          id: `delivery-${delivery.id}`,
          type: 'warning',
          priority: 'high',
          title: p('alert_deliveries_title'),
          message: p('alert_deliveries_message', {
            number: delivery.delivery_number || delivery.id,
          }),
          date: (delivery.delivery_date || delivery.created_at || '').split('T')[0],
          read: false,
        })),
        ...pendingOrders.map((order) => ({
          id: `order-${order.id}`,
          type: 'success',
          priority: 'low',
          title: p('alert_goal_title'),
          message: p('alert_goal_message', {
            number: order.order_number || order.id,
          }),
          date: (order.order_date || order.created_at || '').split('T')[0],
          read: false,
        })),
      ];

      setAlerts(mapped);
    } catch (error) {
      console.error('Error loading ventes alerts:', error);
      setAlerts([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModuleAlertsPage
      moduleName={p('module_name')}
      moduleIcon={TrendingUp}
      alerts={alerts}
      loading={loading}
    />
  );
};

export default VentesAlertsPage;
